import api from './api'

export interface User {
  id: number
  name: string
  email: string
  password?: string
  active: boolean
  function: number
  functionId?: number
  workshopCompanyId?: number
  functionName?: string
  companyName?: string
  phone?: string
}

export interface CreateUserRequest {
  name: string
  email: string
  password: string
  active?: boolean
  functionId: number
  workshopCompanyId?: number
  phone?: string
}

export interface UserProfile {
  id: number
  name: string
  email: string
  phone?: string
  functionId?: number
  functionName?: string
  workshopCompanyId?: number
}

export interface StorageUsageStatus {
  planCode?: string | null
  usedBytes?: number | null
  quotaBytes?: number | null
  maxAttachmentBytes?: number | null
  usedPercent?: number | null
  usedLabel?: string | null
  quotaLabel?: string | null
}

export interface EntryLevelStatus {
  code: string | null
  name: string | null
  startedAt: string | null
  deadlineAt: string | null
  daysRemaining: number | null
  expired: boolean | null
  applicationAccess?: boolean | null
  aiEnabled?: boolean | null
  storage?: StorageUsageStatus | null
}

export const userService = {
  getById: async (id: number): Promise<User> => {
    const response = await api.get<User>(`/users/${id}`)
    return response.data
  },

  /** Perfil com functionName (recomendado para página de dados pessoais) */
  getProfile: async (id: number): Promise<UserProfile> => {
    const response = await api.get<UserProfile>(`/users/${id}/profile`)
    return response.data
  },

  getByWorkshop: async (workshopCompanyId: number): Promise<User[]> => {
    const response = await api.get<User[]>(`/users/workshop/${workshopCompanyId}`)
    return response.data
  },

  getActiveByWorkshop: async (workshopCompanyId: number): Promise<User[]> => {
    const response = await api.get<User[]>(`/users/workshop/${workshopCompanyId}/active`)
    return response.data
  },

  getInactiveByWorkshop: async (workshopCompanyId: number): Promise<User[]> => {
    const response = await api.get<User[]>(`/users/workshop/${workshopCompanyId}/inactive`)
    return response.data
  },

  create: async (data: CreateUserRequest): Promise<User> => {
    const response = await api.post<User>('/users/workshop', data)
    return response.data
  },

  update: async (id: number, data: Partial<CreateUserRequest>): Promise<User> => {
    const response = await api.put<User>(`/users/${id}`, data)
    return response.data
  },

  /** Atualizar os próprios dados (nome, email, telefone, password). Não altera função. */
  updateOwnProfile: async (data: {
    name: string
    email: string
    phone?: string
    currentPassword?: string
    newPassword?: string
  }): Promise<User> => {
    const response = await api.patch<User>('/users/me', data)
    return response.data
  },

  getEntryLevelStatus: async (): Promise<EntryLevelStatus> => {
    const response = await api.get<{ data: EntryLevelStatus }>(`/entry-level/me`)
    return response.data.data
  },

  toggleStatus: async (id: number): Promise<User> => {
    const response = await api.patch<User>(`/users/${id}/toggle-status`)
    return response.data
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/users/${id}`)
  },
}







